enum BadgeCategory {
  Restrictive = 'restrictive',
  Dietary = 'dietary',
  Other = 'other',
  NonFiltering = 'non-filtering',
  Hidden = 'hidden',
  Warning = 'warning',
}

export type FilterableBadgeCategory =
  | BadgeCategory.Restrictive
  | BadgeCategory.Dietary
  | BadgeCategory.Other;

export { BadgeCategory };
